import { mediaUrl } from '@/lib/mediaUrl';
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { toast } from 'sonner';
import { Check } from 'lucide-react';

const FlashcardElement = ({ config, element, onComplete, onSaveData, isCompleted, progress }) => {
  const cards = config.cards || [];
  const [currentCard, setCurrentCard] = useState(0);
  const [flipped, setFlipped] = useState(false);
  const [mastered, setMastered] = useState(new Set(progress?.element_progress?.[element.id]?.mastered || []));
  if (cards.length === 0) return <p className="text-slate-500 italic">No flashcards configured.</p>;
  const card = cards[currentCard];
  const allMastered = mastered.size >= cards.length;
  const handleMaster = () => { const n = new Set(mastered); n.add(card.id); setMastered(n); onSaveData({ mastered: Array.from(n) }); if (n.size >= cards.length && !isCompleted) { onComplete(); toast.success('All flashcards mastered!'); } nextCard(); };
  const nextCard = () => { setFlipped(false); setCurrentCard(prev => (prev + 1) % cards.length); };
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between"><span className="text-sm text-slate-500">Card {currentCard + 1} of {cards.length}</span><Badge variant="outline" className="text-green-700">{mastered.size}/{cards.length} mastered</Badge></div>
      <button onClick={() => setFlipped(!flipped)} className="w-full min-h-[200px] p-8 rounded-2xl border-2 border-slate-200 bg-white hover:border-[#20acf6] transition-all cursor-pointer text-center" data-testid="flashcard" aria-label={flipped ? 'Showing answer' : 'Click to flip'}>
        <p className="text-xs text-slate-400 mb-3">{flipped ? 'Answer' : 'Question'} (click to flip)</p>
        <p className="text-lg font-medium text-slate-800">{flipped ? card.back_text : card.front_text}</p>
        {flipped && card.back_image_url && <img src={mediaUrl(card.back_image_url)} alt={card.back_image_alt || ""} className="mx-auto mt-3 max-h-32 rounded-lg" />}
        {!flipped && card.front_image_url && <img src={mediaUrl(card.front_image_url)} alt={card.front_image_alt || ""} className="mx-auto mt-3 max-h-32 rounded-lg" />}
      </button>
      <div className="flex gap-3 justify-center">
        {flipped && (<><Button variant="outline" onClick={nextCard}>Still Learning</Button><Button onClick={handleMaster} className="bg-green-600 hover:bg-green-700" disabled={mastered.has(card.id)} data-testid="master-card-btn"><Check className="h-4 w-4 mr-2" /> {mastered.has(card.id) ? 'Mastered' : 'Got It!'}</Button></>)}
      </div>
      {allMastered && !isCompleted && <Button onClick={onComplete} className="bg-[#20acf6] hover:bg-[#3bb8f7] w-full" data-testid="complete-flashcards-btn"><Check className="h-4 w-4 mr-2" /> Complete Flashcards</Button>}
    </div>
  );
};

export default FlashcardElement;
